// ================================================================
//  AgentConnectionErrorDialogController
//  Read-only viewer for one environment's agent_connection failure detail
//  — the short agent_connection_error is already shown as a hover tooltip
//  wherever the "Down" badge appears; this dialog is for the full picture
//  (interceptor identity, the error, and its stack trace) once that
//  one-line tooltip isn't enough to diagnose the problem.
//
//  Locals injected:
//    - agentConnection : env.agent_connection (or envStatus.agent_connection)
//                        — agent_id/agent_name/is_agent_reachable/
//                        agent_connection_error/agent_connection_stacktrace
//    - envName         : the environment name, for the dialog title
// ================================================================

angular.module('bizmetryApp').controller('AgentConnectionErrorDialogController', function (
    $mdDialog, agentConnection, envName
) {
    var vm = this;

    vm.envName = envName;
    vm.agentConnection = agentConnection || {};

    vm.cancel = function () { $mdDialog.cancel(); };
});
